import { useMineCompany } from '@/features/company/hooks/useMineCompany'
import { useGovernmentAllocationEntry } from '@/features/governmentAllocations/hooks/useGovernmentAllocationEntry'
import { governmentAllocationFormStateOptions } from '@/features/governmentAllocations/pages/Update/constants/governmentAllocationFormStateOptions.constant'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'
import { useCompanyBranch } from '@/common/hooks/queries/useCompanyBranch'
import UpdateGovernmentAllocationLoadingState from './components/UpdateGovernmentAllocationLoadingState'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import { useMemo } from 'react'

const Update = () => {
  const { id } = useParams()

  const { data: company, isPending: companyIsPending } = useMineCompany()

  const {
    data: governmentAllocation,
    isPending: governmentAllocationIsPending,
    refetch: refetchGovernmentAllocation,
    error: errorGovernmentAllocation = {} as any,
  } = useGovernmentAllocationEntry(id || '')

  const {
    data: branchData,
    isPending: branchDataIsPending
  } = useCompanyBranch(governmentAllocation?.government_allocation?.branch_id || '', !!governmentAllocation?.government_allocation?.branch_id)

  const statusCode = useMemo(() => {
    if (governmentAllocation?.government_allocation?.simplified_government_allocation_view) {
      return 404
    }

    return errorGovernmentAllocation?.status;
  }, [errorGovernmentAllocation?.status, governmentAllocation?.government_allocation?.simplified_government_allocation_view]);

  if (governmentAllocationIsPending || (branchDataIsPending && governmentAllocation?.government_allocation?.branch_id) || companyIsPending) {
    return <UpdateGovernmentAllocationLoadingState />
  }

  return (
    <ErrorMessageWrapper
      className='h-[calc(100vh-64px)]'
      statusCode={statusCode}
      refetchFunction={refetchGovernmentAllocation}
    >
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-4 items-center">
            <GoBackButton
              fallback="/government-allocations"
              searchLastRouteFromReference={`/government-allocations/${id}`}
            />

            <div className="flex items-center gap-1">
              <p className="text-white-400">{company?.matrix_branch?.general_information?.fantasy_name}</p>

              {branchData?.display_name && (
                <>
                  <ChevronsRightIcon className="text-white-400" />
                  <p className="text-white-800">{branchData.display_name}</p>
                </>
              )}

              {governmentAllocation && (
                <>
                  <ChevronsRightIcon className="text-white-400" />
                  <p className="text-white-800">{governmentAllocation.office_number}</p>
                </>
              )}
            </div>
          </div>
        </div>

        {!governmentAllocationIsPending && governmentAllocation && id && (
          <>
            {governmentAllocationFormStateOptions
              .filter(({ value }) => value === governmentAllocation.status)
              .map(({ comp: Comp }) => {
                return <Comp key={governmentAllocation.id} governmentAllocation={governmentAllocation} />
              })}
          </>
        )}
      </div>
    </ErrorMessageWrapper>
  )
}

export default Update
